import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../firebase/AuthProvider';
import { BrandLoader } from '../components/ui/Logo/BrandLoader';

export function canAccessPlanning(roles: Array<{ name?: string }> | null | undefined): boolean {
  return !!roles?.some(role => ['SUPER ADMIN', 'DEVELOPER'].includes(role.name?.trim().toUpperCase() || ''));
}

export default function PlanningRouteGuard({ children }: { children: React.ReactNode }) {
  const { currentUser, currentRoles, isLoading } = useAuth();
  if (isLoading || currentRoles === null) return <BrandLoader />;
  if (!currentUser || !canAccessPlanning(currentRoles)) return <Navigate to="/forbidden" replace />;
  return <>{children}</>;
}
